export default "__VITE_ASSET__a711d14f__"